const Menu = [
  {
    header: 'Surveys',
    type: ['Client', 'Manager']
  },
  {
    title: 'Surveys',
    group: 'Survey',
    icon: 'format_list_bulleted',
    name: 'Surveys',
    type: ['Client', 'Manager']
  },
  {
    title: 'Create survey',
    group: 'Survey',
    icon: 'add',
    name: 'SurveyCreate',
    type: ['Client']
  },
  {
    header: 'Contacts',
    type: ['Client', 'Manager']
  },
  {
    title: 'Contacts',
    group: 'Contact',
    icon: 'contacts',
    name: 'Contacts',
    type: ['Client', 'Manager']
  },
  {
    header: 'Devices',
    type: ['Client', 'Manager']
  },
  {
    title: 'Devices',
    group: 'Device',
    icon: 'smartphone',
    name: 'DevicesClients',
    type: ['Client', 'Manager']
  },
  
  {
    title: 'Device groups',
    group: 'Device',
    icon: 'devices',
    name: 'DevicesGroups',
    type: ['Client']
  },
  {
    title: 'Groups organization',
    group: 'Device',
    icon: 'business',
    name: 'DevicesGroupsOrganization',
    type: ['Client']
  },
  {
    header: 'Configuration',
    type: ['Admin']
  },

  {
    title: 'Clients',
    group: 'Client',
    icon: 'work_outline',
    name: 'Clients',
    type: ['Admin']
  },
  {
    title: 'Devices',
    group: 'Devices',
    icon: 'smartphone',
    name: 'Devices',
    type: ['Admin']
  },
  {
    title: 'Users',
    group: 'Users',
    icon: 'people',
    name: 'Users',
    type: ['Admin', 'Client']
  }
];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu_eureka.js